import React from 'react'
import { useForm } from 'react-hook-form'
import { HiOutlineSearch } from 'react-icons/hi'
import Form from '../Form'
import FormItem from '../Form/FormItem'
import Button from '../General/Button'
import InputText from '../Inputs/InputText'
import Switch from '../Inputs/Switch'

const AdvancedClientsForm: React.FC<IAdvancedClients> = ({
  onCloseAdvancedForm,
  onSubmit,
  type,
}) => {
  const form = useForm()

  //   const onSubmit = () => {}

  return (
    <Form form={form} onSubmit={onSubmit} classes="gap-x-2 p-2">
      <HiOutlineSearch
        fontSize={25}
        className="text-primaryGray-400 col-span-1"
      />
      <label className="col-span-11 text-left dark:text-white text-darkere">
        Búsqueda avanzada
      </label>

      <FormItem name="name" classes="lg:col-span-6 col-span-12">
        <InputText small label="Nombre" maxLength={80} isUpperValue={false} />
      </FormItem>

      <FormItem name="document" classes="lg:col-span-6 col-span-12">
        <InputText small label="Documento" maxLength={20} isUpperValue={false} />
      </FormItem>

      <FormItem name="busisnessName" classes="lg:col-span-6 col-span-12">
        <InputText small label="Razón Social" maxLength={80} isUpperValue={false} />
      </FormItem>

      <FormItem name="email" classes="lg:col-span-6 col-span-12">
        <InputText small label="Correo" maxLength={80} isUpperValue={false} />
      </FormItem>

      {/* <FormItem name="fiscalAddress" classes="lg:col-span-6 col-span-12">
        <InputText small label="Dirección Fiscal" maxLength={80} isUpperValue={false} />
      </FormItem> */}

      {type === 'DEALERS' && (
        <FormItem name="contributingSpecial" classes="lg:col-span-6 col-span-12 mt-3 flex">
          <Switch forForm={true} small label="Contribuyente especial" />
        </FormItem>
      )}

      <div className="col-span-12 flex space-x-2 mt-4 px-1 mt-3">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onCloseAdvancedForm()}
          htmlType="button"
        >
          Cancelar
        </Button>

        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          Buscar
        </Button>
      </div>
    </Form>
  )
}

interface IAdvancedClients {
  onCloseAdvancedForm: Function
  onSubmit: Function
  type: 'CLIENTS' | 'DEALERS'
}

export default AdvancedClientsForm
